<template>
  <div class="section section_confirmations">
    <div class="main_container step_1_form main_container_fixed">
      <div class="sub_container w-row">
        <div class="column-10 w-col w-col-3"></div>
        <div class="column-2 w-col w-col-6">
          <img src="@/assets/images/Group-11560.svg" loading="lazy" width="126" alt="" class="image-4" />
          <h1 class="heading-3">{{ $t('FULLFILL_PROMO_CODE_DETAILS') }}</h1>
        </div>
        <div class="column-16 w-col w-col-3"></div>
      </div>
      <div class="sub_container w-form">
        <validation-observer v-slot="{ handleSubmit, reset }">
          <form @submit.prevent="handleSubmit(submitForm)" @reset.prevent="reset" id="email-form" name="email-form" data-name="Email Form" class="main_form stepform_1">
            <div class="w-layout-grid grid-3">
              <div class="form_field">
                <validation-provider class="w-100" :name="$t('ΝΑΜΕ')" rules="required" v-slot="{ errors, classes }">
                  <!-- <div class="form_columns w-row">
                    <div class="column-4 w-clearfix w-col w-col-4"><label for="email" class="field_label">{{$t('ΝΑΜΕ')}}</label></div>
                    <div class="column-13 w-col w-col-8"></div>
                  </div> -->
                  <input v-model="PROMO_CODE" type="text" class="text_field_input text-field w-input" maxlength="256" placeholder="12345678899900000000" />
                  <span :class="classes">{{ errors[0] }}</span>
                </validation-provider>
              </div>
              <div class="form_field">
                <validation-provider class="w-100" :name="$t('ΝΑΜΕ')" rules="required" v-slot="{ errors, classes }">
                  <!-- <div class="form_columns w-row">
                    <div class="column-4 w-clearfix w-col w-col-4"><label for="email" class="field_label">{{$t('ΝΑΜΕ')}}</label></div>
                    <div class="column-13 w-col w-col-8"></div>
                  </div> -->
                  <input v-model="FIELD_2" type="text" class="text_field_input text-field w-input" maxlength="256" placeholder="444444" />
                  <span :class="classes">{{ errors[0] }}</span>
                </validation-provider>
              </div>
              <div class="form_field">
                <validation-provider class="w-100" :name="$t('ΝΑΜΕ')" rules="required" v-slot="{ errors, classes }">
                  <!-- <div class="form_columns w-row">
                    <div class="column-4 w-clearfix w-col w-col-4"><label for="email" class="field_label">{{$t('ΝΑΜΕ')}}</label></div>
                    <div class="column-13 w-col w-col-8"></div>
                  </div> -->
                  <input v-model="FIELD_3" type="text" class="text_field_input text-field w-input" maxlength="256" placeholder="433333" />
                  <span :class="classes">{{ errors[0] }}</span>
                </validation-provider>
              </div>
            </div>
              <div class="columns-7 w-row">
                <div class="column-20 w-col w-col-3"></div>
                <div class="column-19 w-col w-col-6">
                  <button type="submit" class="submit-button submit-button-2 main_button w-button">{{ $t('SUBMIT') }}</button>
                </div>
                <div class="column-21 w-col w-col-3"></div>
              </div>
          </form>
        </validation-observer>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      PROMO_CODE: '',
      FIELD_2: '',
      FIELD_3: ''
    };
  },
  created() {
    if (!(Object.prototype.hasOwnProperty.call(this.$store.state[this.$route.params.product][this.$route.params.product], 'CS_PROMO_CODE'))) {
      this.$router.push({ path: `/${this.$route.params.product}` });
    }
  },

  methods: {
    // ...mapActions(`${this.$route.params.product}`, [`${this.$route.params.product}PromoAction`]),
    async submitForm() {
      await this.$store.dispatch(`${this.$route.params.product}/${this.$route.params.product}PromoAction`, {
        CS_PROMO_CODE: {
          PROMO_CODE: this.PROMO_CODE,
          FIELD_2: this.FIELD_2,
          FIELD_3: this.FIELD_3
        }
      });
      this.$router.push({ path: `/${this.$route.params.product}/offer` });
    }
  }
};
</script>
